import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=70fb81db&scoped=true"
import script from "./ArticleForm.vue?vue&type=script&lang=js"
export * from "./ArticleForm.vue?vue&type=script&lang=js"
import style0 from "./ArticleForm.vue?vue&type=style&index=0&id=70fb81db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb81db",
  null
  
)

/* custom blocks */
import block0 from "@/lang/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=F%3A%5Cctvoicer%5CHelpCenter%5Cweb%5Csrc%5Ccomponents%5CArticleForm.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./ArticleForm.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports